import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeContent";

function SealMark() {
  return (
    <a
      href="#top"
      aria-label="黑料舍 回首页"
      className="flex items-center gap-2.5"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#201b15] text-sm font-bold tracking-wide text-[#e9c579]">
        黑
      </span>
      <span className="flex flex-col leading-none">
        <span className="text-[17px] font-extrabold tracking-[0.08em] text-[#201b15]">
          黑料舍
        </span>
        <span className="mt-1 text-[10px] font-medium tracking-[0.22em] text-[#8a7a5c]">
          私藏档库 · Vault
        </span>
      </span>
    </a>
  );
}

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled
          ? 'border-[#e4d9c4]/80 bg-[#f7f2e7]/90 backdrop-blur-md'
          : 'border-transparent bg-[#f7f2e7]'
      }`}
    >
      <div className="mx-auto flex h-[72px] w-full max-w-[1240px] items-center justify-between px-4 md:px-6">
        <SealMark />

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-[#5d523f] transition-colors hover:bg-[#ece2cd] hover:text-[#201b15]"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="flex items-center gap-2 rounded-full border border-[#d9ccb2] px-3.5 py-2 text-sm text-[#8a7a5c]">
            <i className="ri-search-line text-[15px]" aria-hidden="true" />
            搜档目、找主题…
          </span>
          <a
            href="#shelf"
            className="whitespace-nowrap rounded-md bg-[#201b15] px-4 py-2 text-sm font-semibold text-[#e9c579] transition-colors hover:bg-[#322a20]"
          >
            进入宝库目录
          </a>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-[#d9ccb2] text-xl text-[#201b15] lg:hidden"
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <div className="border-t border-[#e4d9c4] bg-[#f7f2e7] px-4 pb-4 pt-2 lg:hidden">
          <div className="grid gap-1">
            {navLinks.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-[#5d523f] hover:bg-[#ece2cd] hover:text-[#201b15]"
              >
                {n.label}
              </a>
            ))}
          </div>
          <a
            href="#shelf"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-md bg-[#201b15] px-4 py-2.5 text-center text-sm font-semibold text-[#e9c579]"
          >
            进入宝库目录
          </a>
        </div>
      )}
    </header>
  );
}